import { useMemo } from "react";

import { useComment } from "../../../../../../../reactQuery/cards";
import {
  getResponseData,
} from "../../../../../../../reactQuery/response";
import { sortByDateDescending } from "../../hooks/commentUtils";

export function useDetailCommentsList(cardId) {
  const {
    isLoading: isCommentLoading,
    comment,
    isError: isCommentError,
  } = useComment(cardId);

  const sortedComments = useMemo(
    () => sortByDateDescending(getResponseData(comment, []), "comment_time"),
    [comment]
  );

  return {
    isCommentError,
    isCommentLoading,
    sortedComments,
  };
}
